import script from "./ComingSoonMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComingSoonMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ComingSoonMessage.vue?vue&type=style&index=0&id=472444a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-472444a9"]])

export default __exports__